module.exports = "<pt-nav title=\"Cadeler Back Office\">\n\n</pt-nav>\n"